import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { EICFTemplatesApi } from '../../../apis/EICFApi/EICFTemplatesApi.ts';

export function useGetEICFTemplatesByFacility(facilityId: number | null | undefined) {
    return useQuery({
        queryKey: [QueryKeys.eicfTemplates, facilityId],
        queryFn: () => EICFTemplatesApi.getByFacility(facilityId as number),
        enabled: !!facilityId && facilityId > 0,
    });
}
